module.exports = __webpack_public_path__ + "static/media/score_n_share_logo.ec601d5b.png";